import Config from 'Config';

import { createApiClient } from '../api-client-factory';

const client = createApiClient(`${Config.accounts_api_url}/v2/sessions`);

/**
 * Sessions API client.
 */
export const sessionsClient = {
  /**
   * Remove current session.
   */
  removeCurrent: async (token: string) => client.delete<void>('my', {}, token),

  /**
   * Remove current session.
   */
  removeAll: async (token: string) => client.delete<void>('', {}, token),
};
